import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=abd1a48e&scoped=true&"
import script from "./Capacity.vue?vue&type=script&lang=js&"
export * from "./Capacity.vue?vue&type=script&lang=js&"
import style0 from "./Capacity.vue?vue&type=style&index=0&id=abd1a48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd1a48e",
  null
  
)

export default component.exports